import { render, staticRenderFns } from "./ProductRegBreadCrumb.vue?vue&type=template&id=dbd3ceb4&scoped=true"
import script from "./ProductRegBreadCrumb.vue?vue&type=script&lang=js"
export * from "./ProductRegBreadCrumb.vue?vue&type=script&lang=js"
import style0 from "./ProductRegBreadCrumb.vue?vue&type=style&index=0&id=dbd3ceb4&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbd3ceb4",
  null
  
)

export default component.exports